import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import vuetify from './plugins/vuetify'
import './plugins'
import moment from 'moment'

import './styles/_custom.scss'

// Import the Auth0 configuration
import { domain, clientId } from '../auth_config.json'

// Import the plugin here
import { Auth0Plugin } from './auth'


Vue.config.productionTip = false


Vue.use(require('vue-moment'), {
  moment
});


import axios from 'axios'

Vue.use({
    install (Vue) {
    Vue.prototype.$api = axios.create({
      baseURL: 'http://localhost:7071/api/'
    })

  }});

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    )
  }
})

Vue.router = router;

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
 // render: h => h(App),
  render: function (h) { return h(App) }
}).$mount('#app')
